import { Middleware } from "@reduxjs/toolkit";
import { setSelectedCompany } from "../slices/authSlice";
import { clearResourcesOnCompanyChange } from "../slices/ResourcesSlice";
import { refreshCompanyData } from "../thunks/companyDataThunks";
import { AppDispatch } from "../store";

export const companyChangeMiddleware: Middleware =
  (store) => (next) => (action) => {
    const prevState = store.getState() as any;
    const result = next(action);
    const newState = store.getState() as any;

    if (
      (action as any).type === setSelectedCompany.type &&
      prevState.auth.companyKey !== newState.auth.companyKey
    ) {
      // Prevent stale calendar resource filters from previous company.
      (store.dispatch as AppDispatch)(clearResourcesOnCompanyChange());

      // רענון נתוני החברה החדשה ללא hard reload
      const { token } = newState.auth;
      if (token && newState.auth.companyKey) {
        (store.dispatch as AppDispatch)(
          refreshCompanyData({
            token,
            companyKey: newState.auth.companyKey,
          }),
        );
      }
    }

    return result;
  };
